<template>
  <card>
    <h5
      slot="header"
      class="card-title text-danger font-weight-bold"
    >
      Ticket Goals
    </h5>
    <div
      class="ml-2"
      style="line-height:1.6em;font-size:18px;"
    >
      <div>
        <router-link to="/participant/ticket?g=1">
          <span>
            <div
              class="row align-items-center"
              :title="statuses[goalZero.TicketGoalStatus].badgeToolTip"
            >
              <div
                class="mr-2 p-0"
                style="line-height:1.2em;"
                :class="statuses[goalZero.TicketGoalStatus].badgeClass"
              >
                {{ statuses[goalZero.TicketGoalStatus].badge }}
              </div>
              <div class="content-heading">{{ goalZero.GoalName }}</div>
            </div>
          </span>
        </router-link>
      </div>
      <div>
        <router-link to="/participant/ticket?g=2">
          <span>
            <div
              class="row align-items-center"
              :title="statuses[goalOne.TicketGoalStatus].badgeToolTip"
            >
              <div
                class="mr-2 p-0"
                style="line-height:1.2em;"
                :class="statuses[goalOne.TicketGoalStatus].badgeClass"
              >
                {{ statuses[goalOne.TicketGoalStatus].badge }}
              </div>
              <div class="content-heading">{{ goalOne.GoalName }}</div>
            </div>
          </span>
        </router-link>
      </div>
      <div>
        <router-link to="/participant/ticket?g=3">
          <span>
            <div
              class="row align-items-center"
              :title="statuses[goalTwo.TicketGoalStatus].badgeToolTip"
            >
              <div
                class="mr-2 p-0"
                style="line-height:1.2em;"
                :class="statuses[goalTwo.TicketGoalStatus].badgeClass"
              >
                {{ statuses[goalTwo.TicketGoalStatus].badge }}
              </div>
              <div class="content-heading">{{ goalTwo.GoalName }}</div>
            </div>
          </span>
        </router-link>
      </div>
      <div>
        <router-link to="/participant/ticket?g=4">
          <span>
            <div
              class="row align-items-center"
              :title="statuses[goalThree.TicketGoalStatus].badgeToolTip"
            >
              <div
                class="mr-2 p-0"
                style="line-height:1.2em;"
                :class="statuses[goalThree.TicketGoalStatus].badgeClass"
              >
                {{ statuses[goalThree.TicketGoalStatus].badge }}
              </div>
              <div class="content-heading">{{ goalThree.GoalName }}</div>
            </div>
          </span>
        </router-link>
      </div>
      <div>
        <router-link to="/participant/ticket?g=5">
          <span>
            <div
              class="row align-items-center"
              :title="statuses[goalFour.TicketGoalStatus].badgeToolTip"
            >
              <div
                class="mr-2 p-0"
                style="line-height:1.2em;"
                :class="statuses[goalFour.TicketGoalStatus].badgeClass"
              >
                {{ statuses[goalFour.TicketGoalStatus].badge }}
              </div>
              <div class="content-heading">{{ goalFour.GoalName }}</div>
            </div>
          </span>
        </router-link>
      </div>
    </div>
  </card>
</template>

<script>
import ticketGoalStatuses from '@/services/static/ticket-goal-statuses'
import ticketStatusApi from '@/services/api/ticket-status'

export default {
  name: 'HomeParticipantGoals',
  data: function () {
    return {
      statuses: [],
      goalZero: {
        TicketGoalStatus: 'New'
      },
      goalOne: {
        TicketGoalStatus: 'New'
      },
      goalTwo: {
        TicketGoalStatus: 'New'
      },
      goalThree: {
        TicketGoalStatus: 'New'
      },
      goalFour: {
        TicketGoalStatus: 'New'
      }
    }
  },
  created: function () {
    this.statuses = ticketGoalStatuses.getStatuses()
  },
  mounted: function () {
    ticketStatusApi.getParticipantStatus(this.$root.scouterKey)
      .then(x => {
        this.goalZero = x[0]
        this.goalOne = x[1]
        this.goalTwo = x[2]
        this.goalThree = x[3]
        this.goalFour = x[4]
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
